import { convertHexToRgbA } from '../utils';

export const BACKGROUND = {
	main: '#191510',
	secondary: '#201D17',
	snackbar: '#000000',
	input: '#2F2D29',
	modalView: convertHexToRgbA('#201D17', 0.8),
	modalViewSecondary: convertHexToRgbA('#191510', 0.8)
};

export const ICON = {
	main: '#AA886A',
	secondary: '#7B756B',
	chevron: '#BBB5AA',
	hover: '#575249',
	pressed: '#80796D',
	alwaysWhite: '#ffffff',
	notification: '#FF3333',
	warning: '#E2B603',
	deposit: '#009E69'
};

export const CONTROL = {
	primary: '#AA886A',
	hover: '#A6876D',
	pressed: '#927965',
	disabled: '#2F2D29',
	secondary: '#4F4A40',
	secondaryHover: '#BBAA0A',
	secondaryPressed: '#BBAA0A',
	dark: '#4F4A40',
	darkHover: '#3E3A32',
	darkPressed: '#312E29',
	darkToggle: '#74736F',
	light: '#ffffff',
	lightHover: '#E5E5E5',
	lightPressed: '#D9D9D9',
	lightToggle: '#B7B7B7'
};

export const TEXT = {
	title: '#F6F6F6',
	subtitle: '#DFDCCE',
	body: '#CFCDC1',
	link: '#00D68F',
	error: '#FF3333',
	warning: '#E2B603',
	alwaysWhite: '#ffffff',
	alwaysDark: '#201D17'
};

export const OTHER = {
	calendarDefault: convertHexToRgbA('#201D17', 0.8),
	calendarActive: '#191510',
	calendarBackgroundWhite: convertHexToRgbA('#ffffff', 0.25),
	calendarTextWhite: '#ffffff',
	calendarBackgroundDarkYellow: '#333217',
	calendarTextYellow: '#EAAE16',
	calendarBackgroundDarkGreen: '#014A2E',
	calendarTextGreen: '#00D07F',
	calendarBackgroundDarkPurple: '#3A2159',
	calendarTextPurple: '#8F6ED4',
	calendarBackgroundDarkBlue: '#19334F',
	calendarTextBlue: '#1D92FF'
};
